import React from "react";
import styled, { css } from "styled-components";

const StyledRelief = styled.div`
  position: relative;
  z-index: 1;
  padding: clamp(3em, 10vw, 5em) 0;
  //transform: translate3d(0,0,0);
  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0;
    bottom: 0;
    left: 50%;
    width: 100vw;
    margin-left: -50vw;
    background-color: inherit;
  }

  ${props => props.hasTopMargin === "true" && css`
    margin-top: calc(2.5 * var(--text-size));
  `}
  ${props => props.hasBottomMargin === "true" && css`
    margin-bottom: calc(2.5 * var(--text-size));
  `}
`;

const DarkRelief = styled(StyledRelief)`
  background-color: var(--theme-background-dark);
  color: var(--theme-text-against-dark);
`;

const LightRelief = styled(StyledRelief)`
  background-color: var(--theme-background-light);
  color: var(--theme-text-against-light);
`;

const OffsetRelief = styled(StyledRelief)`
  background-color: var(--color-offset);
  background-color: transparent;
  color: var(--theme-text-against-light);
  &::before {
    opacity: 0.25;
    background-color: var(--color-offset);
  }
`;

export { DarkRelief, LightRelief, OffsetRelief };